module.exports = __webpack_public_path__ + "static/media/04.b27c1355.webp";